import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import ContactPanel from './ContactPanel';
import { BaseCard } from '../../../components/wizard';

class ContactCard extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  render = () => {
    const { record = {}, data = {}, extras, setItem, ...extraProps } = this.props;
    const formdata = data.data || {};
    return (
      <Box>
        <BaseCard
          cardid={'CONTACT'}
          cardname={'Contact'}
          cardtitle={'Contact & Guardian'}
          instruction={'Provide residential, contact, and guardian information.'}
          step={3}
          buttons={['START', 'CANCEL', 'PREV', 'NEXT', 'GUIDE']}
          {...extraProps}
        >
          <ContactPanel
            data={data}
            record={{ ...record, ...formdata }}
            extras={extras}
            setItem={setItem}
          />
        </BaseCard>
      </Box>
    );
  };
}

ContactCard.propTypes = {
  classes: PropTypes.object,
};

export default ContactCard;
